<script setup lang="ts">
/**
 * Dernier chapitre noir des pages produit en charte « apple » (/cagnotte,
 * /billetterie…, Karim 2026-10-18) : grand titre, bouton d'inscription,
 * lien « Planifier un appel » (Calendly). Textes communs de l'accueil.
 */
import { useCalendlyModal } from "~/composables/useCalendlyModal";
import BoutonApple from "~/components/shared/BoutonApple.vue";
import LienApple from "~/components/shared/LienApple.vue";
import { TITRE_APPLE } from "~/utils/titresApple";

const registerLink = useRegisterLink();
const { openCalendly } = useCalendlyModal();
</script>

<template>
  <section class="bg-black px-4 py-24 text-center sm:px-8 lg:py-32">
    <div class="mx-auto max-w-[820px]">
      <h2 class="[text-wrap:balance] mb-5 text-[40px] text-white sm:text-[64px]" :style="TITRE_APPLE">
        {{ $t("accueil.ctaFinal.titre1") }}
        <span class="text-[#86868b]">{{ $t("accueil.ctaFinal.titre2") }}</span>
      </h2>
      <p class="mx-auto mb-10 max-w-[600px] text-[19px] font-medium leading-[1.45] text-white/70">{{ $t("accueil.ctaFinal.accroche") }}</p>
      <div class="flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
        <BoutonApple v-register-cta="'bandeau-final'" :to="registerLink" grand>
          {{ $t("navigation.appHeader.inscrireAssociation") }}
        </BoutonApple>
        <LienApple clair @click="openCalendly">{{ $t("accueil.ctaFinal.planifierAppel") }}</LienApple>
      </div>
      <p class="mt-8 text-[14px] text-white/50">{{ $t("accueil.ctaFinal.rassurance") }}</p>
    </div>
  </section>
</template>
